<template>
  <v-card>
    <v-card-title>
      {{ $t('REPORTS.MAGAZINE') }}
    </v-card-title>

    <v-container grid-list-md text-md-right fluid fill-height>
      <v-spacer></v-spacer>
      <v-btn @click="getFile">
        {{ $t('BUTTON.EXPORT') }}
      </v-btn>
    </v-container>
  </v-card>
</template>

<script>
import downloadFile from '@/modules/_global/mixins/download-file';
import { ReportsService } from '@/services/reports.service';

export default {
  name: 'Magazine',

  mixins: [downloadFile],

  methods: {
    getFile() {
      ReportsService.getMagazineReport()
        .then(response => {
          const filename = this.$t('REPORTS.MAGAZINE');

          this.downloadFile(response, `${filename}.xlsx`);
        })
        .catch(error => {
          this.$emit('error', error);
        });
    }
  }
};
</script>
